import { LAYER_IDS } from '@tmapy/config';
import { featureToGeoJSONObject } from '@tmapy/mapcore';
import { splitMultiLineStringInPoint } from '../utils/splitMultiLineStringInPoint';
import { actionPrepareSaveFeatures } from './saveEditedFeature';
export const actionMultiLineStringSplitAndSave = (payload) => async (dispatch) => {
    const crossPoint = payload.features.find((feature) => feature.layerId === LAYER_IDS.EDIT_TOOLS_SNAP)?.feature;
    if (!crossPoint)
        return;
    const crossPointCoordinate = crossPoint.getGeometry().getCoordinates();
    const features = payload.features
        .filter((feature) => feature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT)
        .map((feature) => feature.feature);
    const splittedGeoJSONFeatures = [];
    const originalGeoJSONFeatures = features.map(featureToGeoJSONObject);
    features.forEach((feature) => {
        const geometry = feature.getGeometry();
        const geometryType = geometry?.getType();
        if (geometryType === 'MultiLineString') {
            const originalGeoJSONFeature = featureToGeoJSONObject(feature);
            const newCoordinates = splitMultiLineStringInPoint(crossPointCoordinate, geometry.getCoordinates());
            newCoordinates.forEach((coordinates) => {
                splittedGeoJSONFeatures.push({
                    ...originalGeoJSONFeature,
                    id: undefined,
                    crs: originalGeoJSONFeature.properties?._crs,
                    geometry: {
                        type: 'MultiLineString',
                        coordinates,
                    },
                });
            });
        }
        else {
            throw new Error(`Invalid geometry type ${geometryType}`);
        }
    });
    const dataToSave = splittedGeoJSONFeatures.map((splittedGeoJSONFeature) => ({
        layerId: splittedGeoJSONFeature.properties?._originLayerId,
        featureId: null,
        feature: splittedGeoJSONFeature,
    }));
    const splitData = originalGeoJSONFeatures.map((feature) => ({
        layerId: feature.properties?._originLayerId,
        featureId: feature.id,
        feature: null,
    }));
    await dispatch(actionPrepareSaveFeatures([...dataToSave, ...splitData])).meta.responsePromise;
};
//# sourceMappingURL=actionMultiLineStringSplitAndSave.js.map